/**
 * Wrap `navigator.geolocation.getCurrentPosition` in a Promise that resolves
 * with `{latitude, longitude, accuracy}` or rejects with a user-friendly Error.
 */
export function getCurrentPosition(opts = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported on this device"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        }),
      (err) => {
        const map = {
          1: "Location permission denied. Allow location in your browser settings.",
          2: "Location unavailable. Try again outdoors or with better signal.",
          3: "Location request timed out. Please try again.",
        };
        reject(new Error(map[err.code] || "Could not read your location"));
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0, ...opts }
    );
  });
}
